import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { BackToTop } from './components/shared/BackToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { EquipmentPage } from './pages/EquipmentPage';
import { CSRPage } from './pages/CSRPage';
import { QAQCPage } from './pages/QAQCPage';
import { HSEPage } from './pages/HSEPage';
import { ContactPage } from './pages/ContactPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
        <Route path="/portfolio" element={<PortfolioPage data-id="element-9" />} data-id="element-8" />
        <Route path="/equipment" element={<EquipmentPage data-id="element-11" />} data-id="element-10" />
        <Route path="/csr" element={<CSRPage data-id="element-13" />} data-id="element-12" />
        <Route path="/qaqc" element={<QAQCPage data-id="element-15" />} data-id="element-14" />
        <Route path="/hse" element={<HSEPage data-id="element-17" />} data-id="element-16" />
        <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <Router data-id="element-20">
      <ScrollToTop data-id="element-21" />
      <div className="min-h-screen bg-white" data-id="element-22">
        <Header data-id="element-23" />
        <AnimatedRoutes data-id="element-24" />
        <Footer data-id="element-25" />
        <BackToTop data-id="element-26" />
      </div>
    </Router>;
}